import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreyIconLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8632 8.18856C11.7364 8.18856 11.6315 8.08886 11.6315 7.96315C11.6315 7.83744 11.7321 7.7334 11.8632 7.7334C11.99 7.7334 12.0906 7.83744 12.0906 7.96315C12.0906 8.08452 11.99 8.18856 11.8632 8.18856Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5309 7.10051C11.5309 6.97046 11.6359 6.86642 11.767 6.86642C11.8982 6.86642 12.0032 6.97046 12.0032 7.10051C12.0032 7.23055 11.8982 7.33459 11.767 7.33459C11.6359 7.33459 11.5309 7.23055 11.5309 7.10051Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4741 6.05582C11.6009 6.05582 11.7015 6.15552 11.7015 6.28123C11.7015 6.40694 11.6009 6.51098 11.4741 6.51098C11.3473 6.51098 11.2467 6.40694 11.2467 6.28123C11.2467 6.15985 11.3473 6.05582 11.4741 6.05582Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0104 5.80005C10.8705 5.80005 10.7612 5.68735 10.7612 5.55297C10.7612 5.41425 10.8749 5.30588 11.0104 5.30588C11.1504 5.30588 11.2597 5.41859 11.2597 5.55297C11.2641 5.68735 11.1504 5.80005 11.0104 5.80005Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.394 4.69031C10.534 4.69031 10.6433 4.80302 10.6433 4.9374C10.6433 5.07611 10.5296 5.18448 10.394 5.18448C10.2541 5.18448 10.1448 5.07178 10.1448 4.9374C10.1448 4.80302 10.2541 4.69031 10.394 4.69031Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.65497 4.23953C9.79053 4.23953 9.89985 4.3479 9.89985 4.48229C9.89985 4.61667 9.79053 4.72504 9.65497 4.72504C9.51942 4.72504 9.4101 4.61667 9.4101 4.48229C9.41447 4.3479 9.52379 4.23953 9.65497 4.23953Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83299 3.98373C8.95105 3.98373 9.04288 4.0791 9.04288 4.19181C9.04288 4.30885 8.94668 4.39988 8.83299 4.39988C8.71492 4.39988 8.6231 4.30451 8.6231 4.19181C8.6231 4.0791 8.71492 3.98373 8.83299 3.98373Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.15067 4.09646C8.15067 4.19617 8.06758 4.27853 7.96701 4.27853C7.86644 4.27853 7.78336 4.19617 7.78336 4.09646C7.78336 3.99676 7.86644 3.9144 7.96701 3.9144C8.06758 3.9144 8.15067 3.99676 8.15067 4.09646Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2674 4.19616C7.2674 4.28719 7.19306 4.36088 7.10123 4.36088C7.00941 4.36088 6.93507 4.28719 6.93507 4.19616C6.93507 4.10512 7.00941 4.03143 7.10123 4.03143C7.19306 4.0271 7.2674 4.10079 7.2674 4.19616Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.45859 4.48225C6.45859 4.58195 6.37551 4.65998 6.27931 4.65998C6.17874 4.65998 6.10003 4.57761 6.10003 4.48225C6.10003 4.38254 6.18311 4.30452 6.27931 4.30452C6.37551 4.30018 6.45859 4.38254 6.45859 4.48225Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.53594 4.72937C5.654 4.72937 5.74583 4.82474 5.74583 4.93744C5.74583 5.05449 5.64963 5.14552 5.53594 5.14552C5.41788 5.14552 5.32605 5.05015 5.32605 4.93744C5.32605 4.82474 5.42225 4.72937 5.53594 4.72937Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.91921 5.34921C5.0329 5.34921 5.12473 5.44025 5.12473 5.55295C5.12473 5.66566 5.0329 5.75669 4.91921 5.75669C4.80552 5.75669 4.71369 5.66566 4.71369 5.55295C4.71369 5.44025 4.80552 5.34921 4.91921 5.34921Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.45578 6.07751C4.56947 6.07751 4.66567 6.16855 4.66567 6.28559C4.66567 6.3983 4.57385 6.49366 4.45578 6.49366C4.34209 6.49366 4.24589 6.40263 4.24589 6.28559C4.25026 6.16855 4.34209 6.07751 4.45578 6.07751Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.16721 6.87946C4.28965 6.87946 4.39022 6.97916 4.39022 7.10053C4.39022 7.22191 4.28965 7.32161 4.16721 7.32161C4.04477 7.32161 3.9442 7.22191 3.9442 7.10053C3.94857 6.97916 4.04477 6.87946 4.16721 6.87946Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.0709 7.72043C4.20208 7.72043 4.3114 7.8288 4.3114 7.95885C4.3114 8.08889 4.20208 8.19726 4.0709 8.19726C3.93972 8.19726 3.8304 8.08889 3.8304 7.95885C3.8304 7.8288 3.93972 7.72043 4.0709 7.72043Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.91367 8.81713C3.91367 8.67841 4.02736 8.56137 4.17166 8.56137C4.31159 8.56137 4.42965 8.67408 4.42965 8.81713C4.42965 8.95584 4.31596 9.07289 4.17166 9.07289C4.02736 9.07289 3.91367 8.96018 3.91367 8.81713Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.45573 9.89653C4.31143 9.89653 4.19337 9.77949 4.19337 9.63644C4.19337 9.49338 4.31143 9.37634 4.45573 9.37634C4.60003 9.37634 4.7181 9.49338 4.7181 9.63644C4.7181 9.77949 4.60003 9.89653 4.45573 9.89653Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.91926 10.1003C5.06794 10.1003 5.19037 10.2217 5.19037 10.369C5.19037 10.5164 5.06794 10.6378 4.91926 10.6378C4.77059 10.6378 4.64815 10.5164 4.64815 10.369C4.64815 10.2173 4.77059 10.1003 4.91926 10.1003Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.53596 10.6812C5.70212 10.6812 5.83768 10.8155 5.83768 10.9803C5.83768 11.145 5.70212 11.2794 5.53596 11.2794C5.3698 11.2794 5.23424 11.145 5.23424 10.9803C5.23861 10.8155 5.3698 10.6812 5.53596 10.6812Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.27492 11.1406C6.44109 11.1406 6.57664 11.275 6.57664 11.4397C6.57664 11.6045 6.44109 11.7388 6.27492 11.7388C6.10876 11.7388 5.97321 11.6045 5.97321 11.4397C5.97758 11.275 6.10876 11.1406 6.27492 11.1406Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.10131 12.0336C6.9264 12.0336 6.78647 11.8949 6.78647 11.7215C6.78647 11.5481 6.9264 11.4094 7.10131 11.4094C7.27622 11.4094 7.41614 11.5481 7.41614 11.7215C7.41177 11.8949 7.27184 12.0336 7.10131 12.0336Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.64799 11.8212C7.64799 11.6478 7.79229 11.5048 7.9672 11.5048C8.14211 11.5048 8.28641 11.6478 8.28641 11.8212C8.28641 11.9946 8.14211 12.1377 7.9672 12.1377C7.78792 12.1377 7.64799 11.9946 7.64799 11.8212Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.51805 11.7258C8.51805 11.5524 8.65798 11.4137 8.83289 11.4137C9.0078 11.4137 9.14773 11.5524 9.14773 11.7258C9.14773 11.8992 9.0078 12.0379 8.83289 12.0379C8.65798 12.0336 8.51805 11.8949 8.51805 11.7258Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.65503 11.7388C9.48887 11.7388 9.35331 11.6045 9.35331 11.4397C9.35331 11.275 9.48887 11.1406 9.65503 11.1406C9.82119 11.1406 9.95675 11.275 9.95675 11.4397C9.95675 11.6045 9.82119 11.7388 9.65503 11.7388Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.394 11.2273C10.2541 11.2273 10.1448 11.1146 10.1448 10.9802C10.1448 10.8415 10.2585 10.7332 10.394 10.7332C10.534 10.7332 10.6433 10.8459 10.6433 10.9802C10.6477 11.1146 10.534 11.2273 10.394 11.2273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0105 10.5901C10.888 10.5901 10.7875 10.4904 10.7875 10.369C10.7875 10.2477 10.888 10.1479 11.0105 10.1479C11.1329 10.1479 11.2335 10.2477 11.2335 10.369C11.2379 10.4904 11.1373 10.5901 11.0105 10.5901Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.474 9.43271C11.5877 9.43271 11.6795 9.52374 11.6795 9.63645C11.6795 9.74916 11.5877 9.84019 11.474 9.84019C11.3603 9.84019 11.2685 9.74916 11.2685 9.63645C11.2685 9.52374 11.3647 9.43271 11.474 9.43271Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7627 9.03389C11.6446 9.03389 11.5484 8.93852 11.5484 8.82148C11.5484 8.70444 11.6446 8.60907 11.7627 8.60907C11.8807 8.60907 11.9769 8.70444 11.9769 8.82148C11.9813 8.93852 11.8851 9.03389 11.7627 9.03389Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8339 8.17558C12.7158 8.17558 12.6196 8.08021 12.6196 7.96317C12.6196 7.84613 12.7158 7.75076 12.8339 7.75076C12.9519 7.75076 13.0481 7.84613 13.0481 7.96317C13.0525 8.07588 12.9563 8.17558 12.8339 8.17558Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7553 6.87076C12.8821 6.87076 12.9827 6.97046 12.9827 7.10051C12.9827 7.22622 12.8821 7.32592 12.7553 7.32592C12.6285 7.32592 12.5235 7.22622 12.5235 7.10051C12.5279 6.97046 12.6285 6.87076 12.7553 6.87076Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2786 6.2639C12.2786 6.12952 12.388 6.01682 12.5279 6.01682C12.6634 6.01682 12.7771 6.12519 12.7771 6.2639C12.7771 6.39828 12.6678 6.51099 12.5279 6.51099C12.388 6.51099 12.2786 6.39828 12.2786 6.2639Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1474 5.74806C11.9987 5.74806 11.8806 5.63102 11.8806 5.48363C11.8806 5.33625 11.9987 5.21921 12.1474 5.21921C12.296 5.21921 12.4141 5.33625 12.4141 5.48363C12.4141 5.63102 12.2917 5.74806 12.1474 5.74806Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3648 4.7814C11.3648 4.63401 11.4829 4.51697 11.6315 4.51697C11.7802 4.51697 11.8983 4.63401 11.8983 4.7814C11.8983 4.92878 11.7802 5.04582 11.6315 5.04582C11.4872 5.05016 11.3648 4.92878 11.3648 4.7814Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0017 4.44759C10.8574 4.44759 10.7349 4.33054 10.7349 4.18316C10.7349 4.04011 10.853 3.91873 11.0017 3.91873C11.146 3.91873 11.2684 4.03577 11.2684 4.18316C11.2684 4.33054 11.1503 4.44759 11.0017 4.44759Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0222 3.71065C10.0222 3.57193 10.1359 3.46356 10.2715 3.46356C10.4114 3.46356 10.5207 3.57627 10.5207 3.71065C10.5207 3.84937 10.407 3.95774 10.2715 3.95774C10.1359 3.95774 10.0222 3.84503 10.0222 3.71065Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.47137 3.12109C9.61129 3.12109 9.72061 3.2338 9.72061 3.36818C9.72061 3.5069 9.60692 3.61527 9.47137 3.61527C9.33144 3.61527 9.22212 3.50256 9.22212 3.36818C9.21775 3.22947 9.33144 3.12109 9.47137 3.12109Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.84172 3.17748C8.84172 3.29886 8.74115 3.39856 8.61871 3.39856C8.49628 3.39856 8.3957 3.29886 8.3957 3.17748C8.3957 3.05611 8.49628 2.9564 8.61871 2.9564C8.74552 2.95207 8.84172 3.05177 8.84172 3.17748Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.92777 3.13842C7.92777 3.23379 7.84906 3.31615 7.74849 3.31615C7.65229 3.31615 7.56921 3.23813 7.56921 3.13842C7.56921 3.04306 7.64792 2.96069 7.74849 2.96069C7.84469 2.96069 7.92777 3.03872 7.92777 3.13842Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.04003 3.25118C7.04003 3.33788 6.97006 3.40723 6.88261 3.40723C6.79515 3.40723 6.72519 3.33788 6.72519 3.25118C6.72519 3.16448 6.79515 3.09512 6.88261 3.09512C6.97006 3.09512 7.04003 3.16448 7.04003 3.25118Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.19604 3.51994C6.19604 3.59797 6.13045 3.66299 6.05174 3.66299C5.97303 3.66299 5.90744 3.59797 5.90744 3.51994C5.90744 3.44192 5.97303 3.37689 6.05174 3.37689C6.13045 3.37689 6.19604 3.44192 6.19604 3.51994Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.4485 3.93169C5.4485 4.02273 5.37416 4.09642 5.28233 4.09642C5.19051 4.09642 5.11617 4.02273 5.11617 3.93169C5.11617 3.84066 5.19051 3.76697 5.28233 3.76697C5.37416 3.76697 5.4485 3.84066 5.4485 3.93169Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.60016 4.30884C4.69199 4.30884 4.76632 4.38253 4.76632 4.47356C4.76632 4.5646 4.69199 4.63829 4.60016 4.63829C4.50833 4.63829 4.434 4.5646 4.434 4.47356C4.43837 4.3782 4.50833 4.30884 4.60016 4.30884Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.20221 5.12379C4.20221 5.21916 4.1235 5.29719 4.0273 5.29719C3.9311 5.29719 3.85239 5.21916 3.85239 5.12379C3.85239 5.02843 3.9311 4.9504 4.0273 4.9504C4.1235 4.94606 4.20221 5.02409 4.20221 5.12379Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.57697 5.65704C3.69066 5.65704 3.78686 5.74808 3.78686 5.86512C3.78686 5.97782 3.69503 6.07319 3.57697 6.07319C3.46328 6.07319 3.36708 5.98216 3.36708 5.86512C3.37145 5.75241 3.46328 5.65704 3.57697 5.65704Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.06517 6.67573C3.06517 6.56302 3.157 6.46765 3.27506 6.46765C3.39313 6.46765 3.48495 6.55868 3.48495 6.67573C3.48495 6.78843 3.39313 6.8838 3.27506 6.8838C3.157 6.8838 3.06517 6.78843 3.06517 6.67573Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.1177 7.32162C3.23139 7.32162 3.32759 7.41266 3.32759 7.5297C3.32759 7.64241 3.23577 7.73777 3.1177 7.73777C3.00401 7.73777 2.90781 7.64674 2.90781 7.5297C2.90781 7.41266 2.99964 7.32162 3.1177 7.32162Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.11772 8.17123C3.24016 8.17123 3.34073 8.27094 3.34073 8.39231C3.34073 8.51369 3.24016 8.61339 3.11772 8.61339C2.99529 8.61339 2.89472 8.51369 2.89472 8.39231C2.89034 8.27094 2.99092 8.17123 3.11772 8.17123Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.03037 9.24196C3.03037 9.11191 3.13969 9.00354 3.27087 9.00354C3.40205 9.00354 3.51137 9.11191 3.51137 9.24196C3.51137 9.372 3.40205 9.48038 3.27087 9.48038C3.13969 9.48038 3.03037 9.37634 3.03037 9.24196Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.57692 10.3127C3.43262 10.3127 3.31456 10.1956 3.31456 10.0526C3.31456 9.90952 3.43262 9.79248 3.57692 9.79248C3.72122 9.79248 3.83928 9.90952 3.83928 10.0526C3.83928 10.1956 3.72559 10.3127 3.57692 10.3127Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.30279 10.7982C4.30279 10.9499 4.18035 11.0756 4.02293 11.0756C3.86989 11.0756 3.74308 10.9542 3.74308 10.7982C3.74308 10.6465 3.86551 10.5208 4.02293 10.5208C4.18035 10.5208 4.30279 10.6465 4.30279 10.7982Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.60015 11.158C4.76194 11.158 4.89312 11.288 4.89312 11.4484C4.89312 11.6088 4.76194 11.7388 4.60015 11.7388C4.43835 11.7388 4.30717 11.6088 4.30717 11.4484C4.30717 11.288 4.43835 11.158 4.60015 11.158Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.28231 11.6868C5.44847 11.6868 5.58402 11.8212 5.58402 11.9859C5.58402 12.1506 5.44847 12.285 5.28231 12.285C5.11614 12.285 4.98059 12.1506 4.98059 11.9859C4.98059 11.8212 5.11614 11.6868 5.28231 11.6868Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.35799 12.3977C6.35799 12.5668 6.22244 12.7012 6.0519 12.7012C5.88137 12.7012 5.74581 12.5668 5.74581 12.3977C5.74581 12.2287 5.88137 12.0943 6.0519 12.0943C6.22244 12.0943 6.35799 12.2287 6.35799 12.3977Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.88266 12.9959C6.699 12.9959 6.55033 12.8486 6.55033 12.6665C6.55033 12.4844 6.699 12.337 6.88266 12.337C7.06631 12.337 7.21498 12.4844 7.21498 12.6665C7.21498 12.8486 7.06631 12.9959 6.88266 12.9959Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.74845 13.1043C7.56917 13.1043 7.42487 12.9613 7.42487 12.7835C7.42487 12.6058 7.56917 12.4628 7.74845 12.4628C7.92773 12.4628 8.07203 12.6058 8.07203 12.7835C8.07203 12.9613 7.92773 13.1043 7.74845 13.1043Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.61873 13.061C8.43944 13.061 8.29515 12.9179 8.29515 12.7402C8.29515 12.5625 8.43944 12.4238 8.61873 12.4238C8.79801 12.4238 8.94231 12.5668 8.94231 12.7402C8.94231 12.9179 8.79801 13.061 8.61873 13.061Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.47141 12.8399C9.30962 12.8399 9.17844 12.7099 9.17844 12.5495C9.17844 12.3891 9.30962 12.259 9.47141 12.259C9.6332 12.259 9.76439 12.3891 9.76439 12.5495C9.76439 12.7099 9.6332 12.8399 9.47141 12.8399Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.98296 12.2113C9.98296 12.0553 10.1141 11.9252 10.2716 11.9252C10.4333 11.9252 10.5602 12.0553 10.5602 12.2113C10.5602 12.3717 10.429 12.4974 10.2716 12.4974C10.1141 12.4974 9.98296 12.3674 9.98296 12.2113Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0017 11.9816C10.8661 11.9816 10.7525 11.8732 10.7525 11.7345C10.7525 11.6001 10.8618 11.4874 11.0017 11.4874C11.1373 11.4874 11.2509 11.5958 11.2509 11.7345C11.2509 11.8689 11.1373 11.9816 11.0017 11.9816Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6314 11.3314C11.5221 11.3314 11.4346 11.2447 11.4346 11.1363C11.4346 11.0279 11.5221 10.9412 11.6314 10.9412C11.7407 10.9412 11.8282 11.0279 11.8282 11.1363C11.8282 11.2447 11.7407 11.3314 11.6314 11.3314Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1474 10.6378C12.0337 10.6378 11.9419 10.5467 11.9419 10.434C11.9419 10.3213 12.0337 10.2303 12.1474 10.2303C12.2611 10.2303 12.353 10.3213 12.353 10.434C12.353 10.5467 12.2611 10.6378 12.1474 10.6378Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3312 9.65375C12.3312 9.54538 12.4186 9.46301 12.5236 9.46301C12.6329 9.46301 12.716 9.54971 12.716 9.65375C12.716 9.76212 12.6285 9.84448 12.5236 9.84448C12.4186 9.84882 12.3312 9.76212 12.3312 9.65375Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.541 8.82148C12.541 8.70444 12.6372 8.60907 12.7553 8.60907C12.8734 8.60907 12.9696 8.70444 12.9696 8.82148C12.9696 8.93852 12.8734 9.03389 12.7553 9.03389C12.6372 9.03389 12.541 8.93852 12.541 8.82148Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5685 7.95885C13.5685 7.8288 13.6778 7.72043 13.809 7.72043C13.9401 7.72043 14.0495 7.8288 14.0495 7.95885C14.0495 8.08889 13.9401 8.19726 13.809 8.19726C13.6778 8.19726 13.5685 8.09323 13.5685 7.95885Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7434 6.84045C13.8877 6.84045 14.0014 6.9575 14.0014 7.09621C14.0014 7.23926 13.8833 7.35197 13.7434 7.35197C13.5991 7.35197 13.4854 7.23493 13.4854 7.09621C13.4854 6.95316 13.5991 6.84045 13.7434 6.84045Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2755 6.25091C13.2755 6.09919 13.398 5.97781 13.551 5.97781C13.704 5.97781 13.8265 6.09919 13.8265 6.25091C13.8265 6.40263 13.704 6.52401 13.551 6.52401C13.398 6.52401 13.2755 6.40263 13.2755 6.25091Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2318 5.709C13.0875 5.709 12.9651 5.59196 12.9651 5.44457C12.9651 5.30152 13.0831 5.18015 13.2318 5.18015C13.3761 5.18015 13.4985 5.29719 13.4985 5.44457C13.4942 5.59196 13.3761 5.709 13.2318 5.709Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7945 5.00245C12.624 5.00245 12.484 4.86374 12.484 4.69468C12.484 4.52562 12.624 4.3869 12.7945 4.3869C12.965 4.3869 13.105 4.52562 13.105 4.69468C13.105 4.86807 12.965 5.00245 12.7945 5.00245Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2479 4.29153C12.0949 4.29153 11.9725 4.17015 11.9725 4.01843C11.9725 3.86671 12.0949 3.74533 12.2479 3.74533C12.401 3.74533 12.5234 3.86671 12.5234 4.01843C12.5234 4.17015 12.401 4.29153 12.2479 4.29153Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6095 3.13409C11.7757 3.13409 11.9112 3.26848 11.9112 3.4332C11.9112 3.59793 11.7757 3.73231 11.6095 3.73231C11.4433 3.73231 11.3078 3.59793 11.3078 3.4332C11.3078 3.26848 11.4433 3.13409 11.6095 3.13409Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.888 3.21648C10.7349 3.21648 10.6081 3.09511 10.6081 2.93905C10.6081 2.78733 10.7349 2.66162 10.888 2.66162C11.041 2.66162 11.1678 2.783 11.1678 2.93905C11.1678 3.09511 11.041 3.21648 10.888 3.21648Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3678 2.56628C10.3678 2.71366 10.2498 2.8307 10.1011 2.8307C9.95241 2.8307 9.83435 2.71366 9.83435 2.56628C9.83435 2.41889 9.95241 2.30185 10.1011 2.30185C10.2498 2.30185 10.3678 2.41889 10.3678 2.56628Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.50188 2.3105C9.50188 2.44055 9.39694 2.54458 9.26575 2.54458C9.13457 2.54458 9.02963 2.44055 9.02963 2.3105C9.02963 2.18045 9.13457 2.07642 9.26575 2.07642C9.39694 2.08075 9.50188 2.18479 9.50188 2.3105Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63608 2.18477C8.63608 2.31481 8.53114 2.41885 8.39996 2.41885C8.26878 2.41885 8.16383 2.31481 8.16383 2.18477C8.16383 2.05472 8.26878 1.95068 8.39996 1.95068C8.53114 1.95068 8.63608 2.05472 8.63608 2.18477Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.52983 1.98535C7.63915 1.98535 7.7266 2.07205 7.7266 2.18042C7.7266 2.28879 7.63915 2.37549 7.52983 2.37549C7.42051 2.37549 7.33306 2.28879 7.33306 2.18042C7.33306 2.07638 7.42051 1.98535 7.52983 1.98535Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.82588 2.31047C6.82588 2.39717 6.75591 2.46653 6.66846 2.46653C6.581 2.46653 6.51104 2.39717 6.51104 2.31047C6.51104 2.22378 6.581 2.15442 6.66846 2.15442C6.75591 2.15442 6.82588 2.22378 6.82588 2.31047Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.70204 2.56623C5.70204 2.49688 5.75889 2.43619 5.83323 2.43619C5.90319 2.43619 5.96441 2.49254 5.96441 2.56623C5.96441 2.63559 5.90756 2.69628 5.83323 2.69628C5.75889 2.69628 5.70204 2.63993 5.70204 2.56623Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.19914 2.94335C5.19914 3.02571 5.12917 3.09507 5.04609 3.09507C4.96301 3.09507 4.89305 3.02571 4.89305 2.94335C4.89305 2.86098 4.96301 2.79163 5.04609 2.79163C5.12917 2.79163 5.19914 2.85665 5.19914 2.94335Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.32464 3.57193C4.24593 3.57193 4.18034 3.50691 4.18034 3.42888C4.18034 3.35085 4.24593 3.28583 4.32464 3.28583C4.40335 3.28583 4.46894 3.35085 4.46894 3.42888C4.46457 3.50691 4.40335 3.57193 4.32464 3.57193Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.84801 4.01842C3.84801 4.10946 3.77368 4.18315 3.68185 4.18315C3.59002 4.18315 3.51569 4.10946 3.51569 4.01842C3.51569 3.92739 3.59002 3.8537 3.68185 3.8537C3.77368 3.85803 3.84801 3.92739 3.84801 4.01842Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.29269 4.69466C3.29269 4.77702 3.22273 4.84638 3.13965 4.84638C3.05657 4.84638 2.9866 4.77702 2.9866 4.69466C2.9866 4.6123 3.05657 4.54294 3.13965 4.54294C3.22273 4.54294 3.29269 4.6123 3.29269 4.69466Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.70236 5.27557C2.79418 5.27557 2.87289 5.34927 2.87289 5.44463C2.87289 5.53567 2.79856 5.61369 2.70236 5.61369C2.61053 5.61369 2.53182 5.54 2.53182 5.44463C2.53182 5.3536 2.60616 5.27557 2.70236 5.27557Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.19512 6.25088C2.19512 6.14685 2.2782 6.06448 2.38314 6.06448C2.48372 6.06448 2.57117 6.14685 2.57117 6.25088C2.57117 6.35492 2.48809 6.43728 2.38314 6.43728C2.2782 6.43728 2.19512 6.35492 2.19512 6.25088Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.18628 6.90976C2.29123 6.90976 2.37431 6.99212 2.37431 7.09616C2.37431 7.19586 2.29123 7.28256 2.18628 7.28256C2.08134 7.28256 1.99825 7.2002 1.99825 7.09616C2.00263 6.99212 2.08571 6.90976 2.18628 6.90976Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.1207 8.17989C1.99827 8.17989 1.89769 8.08019 1.89769 7.95881C1.89769 7.83743 1.99827 7.73773 2.1207 7.73773C2.24314 7.73773 2.34371 7.83743 2.34371 7.95881C2.34808 8.08019 2.24751 8.17989 2.1207 8.17989Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.18646 9.04686C2.06403 9.04686 1.96346 8.94716 1.96346 8.82578C1.96346 8.70441 2.06403 8.60471 2.18646 8.60471C2.3089 8.60471 2.40947 8.70441 2.40947 8.82578C2.41385 8.94716 2.31327 9.04686 2.18646 9.04686Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.15135 9.66679C2.15135 9.54108 2.25192 9.44138 2.37873 9.44138C2.50554 9.44138 2.60611 9.54108 2.60611 9.66679C2.60611 9.7925 2.50554 9.8922 2.37873 9.8922C2.25629 9.89654 2.15135 9.7925 2.15135 9.66679Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.95153 10.473C2.95153 10.6074 2.84221 10.7201 2.70228 10.7201C2.56673 10.7201 2.45304 10.6118 2.45304 10.473C2.45304 10.3387 2.56236 10.226 2.70228 10.226C2.83784 10.226 2.95153 10.3387 2.95153 10.473Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.39753 11.223C3.39753 11.3661 3.27947 11.4788 3.13954 11.4788C2.99524 11.4788 2.88155 11.3617 2.88155 11.223C2.88155 11.08 2.99961 10.9673 3.13954 10.9673C3.27947 10.9673 3.39753 11.08 3.39753 11.223Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.68172 11.6175C3.83914 11.6175 3.96595 11.7432 3.96595 11.8993C3.96595 12.0553 3.83914 12.181 3.68172 12.181C3.52431 12.181 3.39312 12.0553 3.39312 11.8993C3.39312 11.7432 3.52431 11.6175 3.68172 11.6175Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.63515 12.4887C4.63515 12.6621 4.49523 12.8009 4.32032 12.8009C4.14541 12.8009 4.00548 12.6621 4.00548 12.4887C4.00548 12.3154 4.14541 12.1766 4.32032 12.1766C4.49523 12.1766 4.63515 12.3154 4.63515 12.4887Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.04614 12.6621C5.22105 12.6621 5.36535 12.8052 5.36535 12.9786C5.36535 13.152 5.22105 13.295 5.04614 13.295C4.87124 13.295 4.72694 13.152 4.72694 12.9786C4.72694 12.8009 4.86686 12.6621 5.04614 12.6621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83314 13.6766C5.65386 13.6766 5.50519 13.5335 5.50519 13.3515C5.50519 13.1737 5.64949 13.0263 5.83314 13.0263C6.01243 13.0263 6.1611 13.1694 6.1611 13.3515C6.15673 13.5292 6.01243 13.6766 5.83314 13.6766Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66401 13.9453C6.47598 13.9453 6.32294 13.7936 6.32294 13.6072C6.32294 13.4208 6.47598 13.269 6.66401 13.269C6.85204 13.269 7.00508 13.4208 7.00508 13.6072C7.00508 13.7936 6.85204 13.9453 6.66401 13.9453Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.52992 14.058C7.35064 14.058 7.20197 13.915 7.20197 13.7329C7.20197 13.5509 7.34627 13.4078 7.52992 13.4078C7.7092 13.4078 7.85787 13.5509 7.85787 13.7329C7.85787 13.915 7.7092 14.058 7.52992 14.058Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.40428 14.0363C8.23811 14.0363 8.10256 13.9019 8.10256 13.7372C8.10256 13.5725 8.23811 13.4381 8.40428 13.4381C8.57044 13.4381 8.70599 13.5725 8.70599 13.7372C8.70599 13.9019 8.57044 14.0363 8.40428 14.0363Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.26579 13.9063C9.09963 13.9063 8.96408 13.7719 8.96408 13.6072C8.96408 13.4424 9.09963 13.308 9.26579 13.308C9.43196 13.308 9.56751 13.4424 9.56751 13.6072C9.56751 13.7719 9.43196 13.9063 9.26579 13.9063Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1011 13.6418C9.93927 13.6418 9.80809 13.5118 9.80809 13.3514C9.80809 13.191 9.93927 13.061 10.1011 13.061C10.2629 13.061 10.394 13.191 10.394 13.3514C10.394 13.5118 10.2629 13.6418 10.1011 13.6418Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.888 13.2084C10.7568 13.2084 10.6519 13.1043 10.6519 12.9743C10.6519 12.8442 10.7568 12.7402 10.888 12.7402C11.0192 12.7402 11.1241 12.8442 11.1241 12.9743C11.1241 13.1043 11.0192 13.2084 10.888 13.2084Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6096 12.6838C11.5003 12.6838 11.4128 12.5971 11.4128 12.4888C11.4128 12.3804 11.5003 12.2937 11.6096 12.2937C11.7189 12.2937 11.8064 12.3804 11.8064 12.4888C11.8064 12.5971 11.7189 12.6838 11.6096 12.6838Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2479 12.116C12.1254 12.116 12.0293 12.0206 12.0293 11.8992C12.0293 11.7778 12.1254 11.6825 12.2479 11.6825C12.3703 11.6825 12.4665 11.7778 12.4665 11.8992C12.4665 12.0206 12.3703 12.116 12.2479 12.116Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9826 11.223C12.9826 11.327 12.8996 11.4094 12.7946 11.4094C12.6897 11.4094 12.6066 11.327 12.6066 11.223C12.6066 11.119 12.6897 11.0366 12.7946 11.0366C12.8996 11.0366 12.9826 11.119 12.9826 11.223Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0351 10.4731C13.0351 10.3647 13.1226 10.278 13.2275 10.278C13.3368 10.278 13.4199 10.3647 13.4199 10.4731C13.4199 10.5814 13.3324 10.6638 13.2275 10.6638C13.1226 10.6638 13.0351 10.5814 13.0351 10.4731Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.551 9.87483C13.4373 9.87483 13.3411 9.7838 13.3411 9.66675C13.3411 9.55405 13.4329 9.45868 13.551 9.45868C13.6646 9.45868 13.7608 9.54971 13.7608 9.66675C13.7565 9.77946 13.6646 9.87483 13.551 9.87483Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7435 9.04687C13.6167 9.04687 13.5161 8.94716 13.5161 8.82145C13.5161 8.69574 13.6167 8.59604 13.7435 8.59604C13.8703 8.59604 13.9709 8.69574 13.9709 8.82145C13.9709 8.94716 13.8703 9.04687 13.7435 9.04687Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.18565 0.992706C8.30372 0.992706 8.39992 1.08807 8.39992 1.20512C8.39992 1.32216 8.30372 1.41752 8.18565 1.41752C8.06759 1.41752 7.97139 1.32216 7.97139 1.20512C7.96702 1.08807 8.06322 0.992706 8.18565 0.992706Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.31124 1.07938C7.39432 1.07938 7.46428 1.14873 7.46428 1.2311C7.46428 1.31346 7.39432 1.38282 7.31124 1.38282C7.22816 1.38282 7.1582 1.31346 7.1582 1.2311C7.1582 1.14873 7.22816 1.07938 7.31124 1.07938Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2174 2.97373C12.0512 2.97373 11.9157 2.83935 11.9157 2.67463C11.9157 2.5099 12.0512 2.37552 12.2174 2.37552C12.3835 2.37552 12.5191 2.5099 12.5191 2.67463C12.5147 2.83935 12.3835 2.97373 12.2174 2.97373Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1985 2.18042C11.1985 2.0157 11.334 1.88132 11.5002 1.88132C11.6664 1.88132 11.8019 2.0157 11.8019 2.18042C11.8019 2.34515 11.6664 2.47953 11.5002 2.47953C11.334 2.47953 11.1985 2.34515 11.1985 2.18042Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7263 2.09374C10.5514 2.09374 10.4115 1.95502 10.4115 1.78162C10.4115 1.60823 10.5514 1.46951 10.7263 1.46951C10.9012 1.46951 11.0411 1.60823 11.0411 1.78162C11.0411 1.95068 10.9012 2.09374 10.7263 2.09374Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.90422 1.20944C10.0573 1.20944 10.1797 1.33082 10.1797 1.48254C10.1797 1.63426 10.0573 1.75564 9.90422 1.75564C9.75118 1.75564 9.62874 1.63426 9.62874 1.48254C9.62874 1.33082 9.75555 1.20944 9.90422 1.20944Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.05596 1.03171C9.19588 1.03171 9.31395 1.14441 9.31395 1.28747C9.31395 1.42618 9.20026 1.54322 9.05596 1.54322C8.91603 1.54322 8.79797 1.43052 8.79797 1.28747C8.79797 1.14875 8.91166 1.03171 9.05596 1.03171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44972 1.21811C6.5328 1.21811 6.60277 1.28747 6.60277 1.36983C6.60277 1.45219 6.5328 1.52155 6.44972 1.52155C6.36664 1.52155 6.29668 1.45219 6.29668 1.36983C6.29668 1.28747 6.36227 1.21811 6.44972 1.21811Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.61022 1.49118C5.68018 1.49118 5.73703 1.54753 5.73703 1.61689C5.73703 1.68625 5.68018 1.7426 5.61022 1.7426C5.54026 1.7426 5.48341 1.68625 5.48341 1.61689C5.48341 1.54753 5.54026 1.49118 5.61022 1.49118Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.81447 1.85101C4.88006 1.85101 4.93253 1.90303 4.93253 1.96806C4.93253 2.03308 4.88006 2.0851 4.81447 2.0851C4.74888 2.0851 4.69641 2.03308 4.69641 1.96806C4.69641 1.90303 4.74888 1.85101 4.81447 1.85101Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06653 2.28882C4.13649 2.28882 4.19334 2.34517 4.19334 2.41453C4.19334 2.48389 4.13649 2.54024 4.06653 2.54024C3.99656 2.54024 3.93972 2.48389 3.93972 2.41453C3.93972 2.34517 3.99656 2.28882 4.06653 2.28882Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.52011 2.9564C3.52011 3.0301 3.4589 3.09078 3.38456 3.09078C3.31022 3.09078 3.24901 3.0301 3.24901 2.9564C3.24901 2.88271 3.31022 2.82202 3.38456 2.82202C3.4589 2.82202 3.52011 2.88271 3.52011 2.9564Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.91225 3.58058C2.91225 3.65427 2.85103 3.71496 2.77669 3.71496C2.70236 3.71496 2.64114 3.65427 2.64114 3.58058C2.64114 3.50689 2.70236 3.4462 2.77669 3.4462C2.85103 3.4462 2.91225 3.50255 2.91225 3.58058Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.40491 4.27417C2.40491 4.35653 2.33495 4.42589 2.25187 4.42589C2.16879 4.42589 2.09882 4.35653 2.09882 4.27417C2.09882 4.1918 2.16879 4.12245 2.25187 4.12245C2.33932 4.11811 2.40491 4.18747 2.40491 4.27417Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.98961 5.02843C1.98961 5.11947 1.91527 5.19316 1.82345 5.19316C1.73162 5.19316 1.65728 5.11947 1.65728 5.02843C1.65728 4.9374 1.73162 4.86371 1.82345 4.86371C1.91527 4.86371 1.98961 4.9374 1.98961 5.02843Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.66165 5.83038C1.66165 5.92141 1.58731 5.9951 1.49548 5.9951C1.40366 5.9951 1.32932 5.92141 1.32932 5.83038C1.32932 5.73934 1.40366 5.66565 1.49548 5.66565C1.58731 5.66565 1.66165 5.73934 1.66165 5.83038Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.27246 6.48929C1.37303 6.48929 1.45174 6.56732 1.45174 6.66702C1.45174 6.76672 1.37303 6.84475 1.27246 6.84475C1.17626 6.84475 1.09318 6.76672 1.09318 6.66702C1.09755 6.57165 1.17626 6.48929 1.27246 6.48929Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.16314 7.3476C1.26371 7.3476 1.34242 7.42562 1.34242 7.52533C1.34242 7.62503 1.26371 7.70305 1.16314 7.70305C1.06694 7.70305 0.983858 7.62503 0.983858 7.52533C0.983858 7.42996 1.06257 7.3476 1.16314 7.3476Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.16324 8.2016C1.27256 8.2016 1.35564 8.2883 1.35564 8.39233C1.35564 8.49637 1.26818 8.58307 1.16324 8.58307C1.05392 8.58307 0.970839 8.49637 0.970839 8.39233C0.970839 8.2883 1.05392 8.2016 1.16324 8.2016Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.07567 9.25061C1.07567 9.14224 1.16312 9.05121 1.27681 9.05121C1.3905 9.05121 1.47796 9.13791 1.47796 9.25061C1.47796 9.35898 1.3905 9.45002 1.27681 9.45002C1.16312 9.45002 1.07567 9.35898 1.07567 9.25061Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.49554 10.2997C1.37748 10.2997 1.28128 10.2043 1.28128 10.0873C1.28128 9.97021 1.37748 9.87485 1.49554 9.87485C1.61361 9.87485 1.70981 9.97021 1.70981 10.0873C1.70981 10.2043 1.61361 10.2997 1.49554 10.2997Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.06824 10.8935C2.06824 11.0279 1.95892 11.1363 1.82336 11.1363C1.68781 11.1363 1.57849 11.0279 1.57849 10.8935C1.57849 10.7591 1.68781 10.6508 1.82336 10.6508C1.95892 10.6508 2.06824 10.7591 2.06824 10.8935Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25187 11.9079C2.10757 11.9079 1.9895 11.7909 1.9895 11.6478C1.9895 11.5048 2.10757 11.3877 2.25187 11.3877C2.39617 11.3877 2.51423 11.5048 2.51423 11.6478C2.51423 11.7909 2.39617 11.9079 2.25187 11.9079Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.77678 12.0683C2.92545 12.0683 3.04789 12.1896 3.04789 12.337C3.04789 12.4844 2.92545 12.6058 2.77678 12.6058C2.62811 12.6058 2.50567 12.4844 2.50567 12.337C2.5013 12.1896 2.62374 12.0683 2.77678 12.0683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.38453 12.6882C3.53757 12.6882 3.66438 12.8096 3.66438 12.9656C3.66438 13.1174 3.54195 13.2431 3.38453 13.2431C3.23148 13.2431 3.10467 13.1217 3.10467 12.9656C3.10467 12.8096 3.23148 12.6882 3.38453 12.6882Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06655 13.1867C4.24146 13.1867 4.38576 13.3298 4.38576 13.5032C4.38576 13.6765 4.24146 13.8196 4.06655 13.8196C3.89165 13.8196 3.74735 13.6765 3.74735 13.5032C3.74735 13.3298 3.89165 13.1867 4.06655 13.1867Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.81427 13.6288C4.99355 13.6288 5.14222 13.7719 5.14222 13.9539C5.14222 14.1317 4.99792 14.279 4.81427 14.279C4.63498 14.279 4.48631 14.136 4.48631 13.9539C4.48631 13.7719 4.63061 13.6288 4.81427 13.6288Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.61023 14.6259C5.43095 14.6259 5.28228 14.4828 5.28228 14.3008C5.28228 14.123 5.42658 13.9756 5.61023 13.9756C5.78952 13.9756 5.93819 14.1187 5.93819 14.3008C5.93819 14.4828 5.79389 14.6259 5.61023 14.6259Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44975 14.8817C6.2661 14.8817 6.11306 14.7343 6.11306 14.5479C6.11306 14.3658 6.26173 14.2141 6.44975 14.2141C6.63341 14.2141 6.78645 14.3615 6.78645 14.5479C6.78208 14.7299 6.63341 14.8817 6.44975 14.8817Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.31127 15.0204C7.12762 15.0204 6.97457 14.873 6.97457 14.6866C6.97457 14.5045 7.12325 14.3528 7.31127 14.3528C7.49493 14.3528 7.64797 14.5002 7.64797 14.6866C7.64797 14.8686 7.49493 15.0204 7.31127 15.0204Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.85787 14.7125C7.85787 14.5348 8.00217 14.3874 8.18582 14.3874C8.36511 14.3874 8.51378 14.5305 8.51378 14.7125C8.51378 14.8903 8.36948 15.0377 8.18582 15.0377C8.00217 15.0377 7.85787 14.8946 7.85787 14.7125Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.74971 14.6302C8.74971 14.4655 8.88527 14.3311 9.05143 14.3311C9.2176 14.3311 9.35315 14.4655 9.35315 14.6302C9.35315 14.7949 9.2176 14.9293 9.05143 14.9293C8.88527 14.9293 8.74971 14.7949 8.74971 14.6302Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.90422 14.7126C9.75118 14.7126 9.62874 14.5912 9.62874 14.4395C9.62874 14.2878 9.75118 14.1664 9.90422 14.1664C10.0573 14.1664 10.1797 14.2878 10.1797 14.4395C10.1797 14.5912 10.0573 14.7126 9.90422 14.7126Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7263 14.3875C10.5863 14.3875 10.477 14.2748 10.477 14.1404C10.477 14.0017 10.5907 13.8933 10.7263 13.8933C10.8662 13.8933 10.9755 14.006 10.9755 14.1404C10.9755 14.2748 10.8662 14.3875 10.7263 14.3875Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5003 13.915C11.4041 13.915 11.321 13.8369 11.321 13.7372C11.321 13.6419 11.3997 13.5595 11.5003 13.5595C11.5965 13.5595 11.6796 13.6375 11.6796 13.7372C11.6796 13.8369 11.5965 13.915 11.5003 13.915Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2175 13.4381C12.1082 13.4381 12.0207 13.3514 12.0207 13.243C12.0207 13.1347 12.1082 13.048 12.2175 13.048C12.3268 13.048 12.4143 13.1347 12.4143 13.243C12.4143 13.3514 12.3268 13.4381 12.2175 13.4381Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8645 12.8139C12.7814 12.8139 12.7114 12.7445 12.7114 12.6622C12.7114 12.5798 12.7814 12.5104 12.8645 12.5104C12.9475 12.5104 13.0175 12.5798 13.0175 12.6622C13.0175 12.7445 12.9475 12.8139 12.8645 12.8139Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4287 11.8256C13.5249 11.8256 13.6036 11.9036 13.6036 11.999C13.6036 12.0943 13.5249 12.1724 13.4287 12.1724C13.3325 12.1724 13.2537 12.0943 13.2537 11.999C13.2537 11.9036 13.3325 11.8256 13.4287 11.8256Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7841 8.19726C14.6529 8.19726 14.5436 8.08889 14.5436 7.95885C14.5436 7.8288 14.6529 7.72043 14.7841 7.72043C14.9152 7.72043 15.0246 7.8288 15.0246 7.95885C15.0246 8.09323 14.9152 8.19726 14.7841 8.19726Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7272 6.83612C14.8715 6.83612 14.9852 6.95316 14.9852 7.09188C14.9852 7.23493 14.8672 7.34764 14.7272 7.34764C14.5829 7.34764 14.4693 7.23059 14.4693 7.09188C14.4693 6.95316 14.5829 6.83612 14.7272 6.83612Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5612 5.97781C14.7099 5.97781 14.8323 6.09919 14.8323 6.24658C14.8323 6.39396 14.7099 6.51534 14.5612 6.51534C14.4126 6.51534 14.2901 6.39396 14.2901 6.24658C14.2901 6.09919 14.4126 5.97781 14.5612 5.97781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.997 5.42291C13.997 5.26686 14.1238 5.14114 14.2812 5.14114C14.4386 5.14114 14.5654 5.26686 14.5654 5.42291C14.5654 5.57897 14.4386 5.70468 14.2812 5.70468C14.1282 5.70901 13.997 5.57897 13.997 5.42291Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9052 4.94178C13.739 4.94178 13.6035 4.8074 13.6035 4.64267C13.6035 4.47795 13.739 4.34357 13.9052 4.34357C14.0714 4.34357 14.2069 4.47795 14.2069 4.64267C14.2069 4.8074 14.0714 4.94178 13.9052 4.94178Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1312 3.91871C13.1312 3.75398 13.2667 3.6196 13.4329 3.6196C13.5991 3.6196 13.7346 3.75398 13.7346 3.91871C13.7346 4.08343 13.5991 4.21781 13.4329 4.21781C13.2624 4.21348 13.1312 4.08343 13.1312 3.91871Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8646 3.58062C12.6853 3.58062 12.541 3.43757 12.541 3.25984C12.541 3.08211 12.6853 2.93906 12.8646 2.93906C13.0439 2.93906 13.1882 3.08211 13.1882 3.25984C13.1882 3.43757 13.0439 3.58062 12.8646 3.58062Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9052 11.0843C14.0101 11.0843 14.0976 11.171 14.0976 11.275C14.0976 11.379 14.0101 11.4657 13.9052 11.4657C13.8002 11.4657 13.7128 11.379 13.7128 11.275C13.7128 11.171 13.8002 11.0843 13.9052 11.0843Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1108 10.4947C14.1108 10.3994 14.1895 10.3214 14.2857 10.3214C14.3819 10.3214 14.4606 10.3994 14.4606 10.4947C14.4606 10.5901 14.3819 10.6681 14.2857 10.6681C14.1895 10.6681 14.1108 10.5901 14.1108 10.4947Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3687 9.67544C14.3687 9.57141 14.4562 9.48471 14.5611 9.48471C14.666 9.48471 14.7535 9.57141 14.7535 9.67544C14.7535 9.77948 14.666 9.86618 14.5611 9.86618C14.4562 9.86184 14.3687 9.77948 14.3687 9.67544Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4955 8.82579C14.4955 8.70008 14.6005 8.59604 14.7273 8.59604C14.8541 8.59604 14.959 8.70008 14.959 8.82579C14.959 8.9515 14.8541 9.05554 14.7273 9.05554C14.6005 9.05554 14.4955 8.9515 14.4955 8.82579Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.755 8.2016C15.6194 8.2016 15.5101 8.09323 15.5101 7.95885C15.5101 7.82447 15.6194 7.71609 15.755 7.71609C15.8906 7.71609 15.9999 7.82447 15.9999 7.95885C16.0042 8.09323 15.8949 8.2016 15.755 8.2016Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7067 7.35631C15.5624 7.35631 15.4444 7.23926 15.4444 7.09621C15.4444 6.95316 15.5624 6.83612 15.7067 6.83612C15.851 6.83612 15.9691 6.95316 15.9691 7.09621C15.9691 7.23926 15.851 7.35631 15.7067 7.35631Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5625 5.96045C15.7199 5.96045 15.8467 6.08616 15.8467 6.24222C15.8467 6.39827 15.7199 6.52398 15.5625 6.52398C15.4051 6.52398 15.2783 6.39827 15.2783 6.24222C15.2783 6.08616 15.4051 5.96045 15.5625 5.96045Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9983 5.40992C14.9983 5.23219 15.1426 5.08914 15.3219 5.08914C15.5012 5.08914 15.6411 5.23219 15.6411 5.40992C15.6411 5.58765 15.4968 5.7307 15.3219 5.7307C15.1426 5.72637 14.9983 5.58332 14.9983 5.40992Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9853 4.9331C14.806 4.9331 14.6574 4.79005 14.6574 4.60798C14.6574 4.43025 14.8017 4.28287 14.9853 4.28287C15.1646 4.28287 15.3133 4.42592 15.3133 4.60798C15.3133 4.78571 15.1646 4.9331 14.9853 4.9331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2376 3.84938C14.2376 3.67165 14.3819 3.52426 14.5656 3.52426C14.7448 3.52426 14.8935 3.66731 14.8935 3.84938C14.8935 4.02711 14.7492 4.17449 14.5656 4.17449C14.3819 4.17449 14.2376 4.02711 14.2376 3.84938Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7435 3.1428C13.7435 2.9694 13.8835 2.83069 14.0584 2.83069C14.2333 2.83069 14.3732 2.9694 14.3732 3.1428C14.3732 3.31619 14.2333 3.45491 14.0584 3.45491C13.8835 3.45491 13.7435 3.31619 13.7435 3.1428Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3473 0.693573C11.5178 0.693573 11.6578 0.832289 11.6578 1.00135C11.6578 1.17041 11.5178 1.30913 11.3473 1.30913C11.1768 1.30913 11.0368 1.17041 11.0368 1.00135C11.0368 0.832289 11.1768 0.693573 11.3473 0.693573Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5383 0.346802C10.7176 0.346802 10.8662 0.489853 10.8662 0.671917C10.8662 0.849647 10.7219 0.997033 10.5383 0.997033C10.359 0.997033 10.2103 0.853982 10.2103 0.671917C10.2147 0.489853 10.359 0.346802 10.5383 0.346802Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.69859 0.138702C9.86038 0.138702 9.99156 0.268749 9.99156 0.429139C9.99156 0.589529 9.86038 0.719576 9.69859 0.719576C9.5368 0.719576 9.40562 0.589529 9.40562 0.429139C9.40999 0.268749 9.5368 0.138702 9.69859 0.138702Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.07336 0.286085C9.07336 0.416131 8.96841 0.520169 8.83723 0.520169C8.70605 0.520169 8.6011 0.416131 8.6011 0.286085C8.6011 0.156039 8.70605 0.052002 8.83723 0.052002C8.96841 0.052002 9.07336 0.156039 9.07336 0.286085Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.2033 0.234083C8.2033 0.36413 8.09836 0.468167 7.96718 0.468167C7.83599 0.468167 7.73105 0.36413 7.73105 0.234083C7.73105 0.104037 7.83599 0 7.96718 0C8.09836 0 8.2033 0.104037 8.2033 0.234083Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2806 0.286104C7.2806 0.390141 7.19751 0.472504 7.09257 0.472504C6.98762 0.472504 6.90454 0.390141 6.90454 0.286104C6.90454 0.182067 6.98762 0.0997042 7.09257 0.0997042C7.19751 0.0953693 7.2806 0.182067 7.2806 0.286104Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.37114 0.429181C6.37114 0.502874 6.30992 0.563562 6.23558 0.563562C6.16125 0.563562 6.10003 0.502874 6.10003 0.429181C6.10003 0.355488 6.16125 0.2948 6.23558 0.2948C6.30992 0.2948 6.37114 0.355488 6.37114 0.429181Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.3915 0.572174C5.44397 0.572174 5.4877 0.615523 5.4877 0.667541C5.4877 0.71956 5.44397 0.762909 5.3915 0.762909C5.33903 0.762909 5.2953 0.71956 5.2953 0.667541C5.2953 0.615523 5.33903 0.572174 5.3915 0.572174Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.58697 0.888672C4.64819 0.888672 4.70067 0.94069 4.70067 1.00138C4.70067 1.06207 4.64819 1.11409 4.58697 1.11409C4.52576 1.11409 4.47328 1.06207 4.47328 1.00138C4.47328 0.94069 4.52138 0.888672 4.58697 0.888672Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4766 2.82201C13.2974 2.82201 13.1487 2.67896 13.1487 2.4969C13.1487 2.31917 13.293 2.17178 13.4766 2.17178C13.6559 2.17178 13.8046 2.31483 13.8046 2.4969C13.8002 2.67896 13.6559 2.82201 13.4766 2.82201Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8251 2.26282C12.6371 2.26282 12.484 2.1111 12.484 1.9247C12.484 1.7383 12.6371 1.58658 12.8251 1.58658C13.0131 1.58658 13.1662 1.7383 13.1662 1.9247C13.1662 2.10676 13.0131 2.26282 12.8251 2.26282Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8021 1.42182C11.8021 1.25276 11.942 1.11404 12.1125 1.11404C12.2831 1.11404 12.423 1.25276 12.423 1.42182C12.423 1.59088 12.2831 1.7296 12.1125 1.7296C11.9376 1.7296 11.8021 1.59088 11.8021 1.42182Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.82177 1.32217C3.87424 1.32217 3.91797 1.36552 3.91797 1.41754C3.91797 1.46956 3.87424 1.51291 3.82177 1.51291C3.76929 1.51291 3.72557 1.46956 3.72557 1.41754C3.72557 1.36552 3.76929 1.32217 3.82177 1.32217Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.9866 1.92036C2.9866 1.85533 3.03908 1.79898 3.10904 1.79898C3.17463 1.79898 3.23147 1.851 3.23147 1.92036C3.23147 1.98538 3.179 2.04173 3.10904 2.04173C3.03908 2.04173 2.9866 1.98538 2.9866 1.92036Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.45741 2.38419C2.51863 2.38419 2.5711 2.4362 2.5711 2.49689C2.5711 2.55758 2.51863 2.6096 2.45741 2.6096C2.39619 2.6096 2.34372 2.55758 2.34372 2.49689C2.34372 2.4362 2.39619 2.38419 2.45741 2.38419Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.87599 3.28152C1.79728 3.28152 1.73606 3.22083 1.73606 3.14281C1.73606 3.06478 1.79728 3.00409 1.87599 3.00409C1.9547 3.00409 2.01592 3.06478 2.01592 3.14281C2.01592 3.22083 1.95033 3.28152 1.87599 3.28152Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.36858 3.70633C1.44729 3.70633 1.51288 3.77135 1.51288 3.84938C1.51288 3.92741 1.44729 3.99243 1.36858 3.99243C1.28987 3.99243 1.22428 3.92741 1.22428 3.84938C1.22428 3.77135 1.28987 3.70633 1.36858 3.70633Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.944546 4.46494C1.02325 4.46494 1.08885 4.52996 1.08885 4.60799C1.08885 4.68601 1.02325 4.75104 0.944546 4.75104C0.865837 4.75104 0.800246 4.68601 0.800246 4.60799C0.800246 4.52996 0.865837 4.46494 0.944546 4.46494Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.612097 5.56165C0.529015 5.56165 0.459052 5.49229 0.459052 5.40993C0.459052 5.32757 0.529015 5.25821 0.612097 5.25821C0.695179 5.25821 0.765142 5.32757 0.765142 5.40993C0.765142 5.49229 0.695179 5.56165 0.612097 5.56165Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.371782 6.08618C0.459237 6.08618 0.5292 6.15554 0.5292 6.24224C0.5292 6.32893 0.459237 6.39829 0.371782 6.39829C0.284328 6.39829 0.214364 6.32893 0.214364 6.24224C0.214364 6.15554 0.284328 6.08618 0.371782 6.08618Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.393594 7.09618C0.393594 7.18722 0.319258 7.26524 0.223058 7.26524C0.131231 7.26524 0.0525217 7.19155 0.0525217 7.09618C0.0525217 7.00515 0.126858 6.92712 0.223058 6.92712C0.319258 6.92712 0.393594 7.00082 0.393594 7.09618Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 7.95883C0 7.86346 0.0787088 7.78543 0.174909 7.78543C0.271108 7.78543 0.349818 7.86346 0.349818 7.95883C0.349818 8.05419 0.271108 8.13222 0.174909 8.13222C0.0787088 8.13222 0 8.05419 0 7.95883Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.411074 8.82583C0.411074 8.92987 0.327992 9.01223 0.223047 9.01223C0.118102 9.01223 0.0350199 8.92987 0.0350199 8.82583C0.0350199 8.72613 0.118102 8.63943 0.223047 8.63943C0.327992 8.63943 0.411074 8.7218 0.411074 8.82583Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.371752 9.87051C0.262434 9.87051 0.179352 9.78382 0.179352 9.67978C0.179352 9.57141 0.266806 9.48904 0.371752 9.48904C0.48107 9.48904 0.564151 9.57574 0.564151 9.67978C0.564151 9.78382 0.476697 9.87051 0.371752 9.87051Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.839514 10.5121C0.839514 10.6378 0.738941 10.7375 0.612133 10.7375C0.485324 10.7375 0.384751 10.6378 0.384751 10.5121C0.384751 10.3864 0.485324 10.2867 0.612133 10.2867C0.738941 10.2867 0.839514 10.3864 0.839514 10.5121Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.944567 11.0843C1.07138 11.0843 1.17195 11.184 1.17195 11.3097C1.17195 11.4354 1.07138 11.5351 0.944567 11.5351C0.817758 11.5351 0.717186 11.4354 0.717186 11.3097C0.721559 11.1883 0.822131 11.0843 0.944567 11.0843Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.6222 12.0683C1.6222 12.207 1.50851 12.3154 1.37295 12.3154C1.23303 12.3154 1.12371 12.2027 1.12371 12.0683C1.12371 11.9296 1.2374 11.8212 1.37295 11.8212C1.50851 11.8212 1.6222 11.9296 1.6222 12.0683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.87586 12.4974C2.0289 12.4974 2.15571 12.6231 2.15571 12.7749C2.15571 12.9266 2.0289 13.0523 1.87586 13.0523C1.72281 13.0523 1.596 12.9266 1.596 12.7749C1.596 12.6231 1.71844 12.4974 1.87586 12.4974Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.45746 13.1433C2.61051 13.1433 2.73731 13.269 2.73731 13.4207C2.73731 13.5725 2.61051 13.6982 2.45746 13.6982C2.30442 13.6982 2.17761 13.5725 2.17761 13.4207C2.17761 13.269 2.30004 13.1433 2.45746 13.1433Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10896 13.6895C3.2795 13.6895 3.41943 13.8282 3.41943 13.9973C3.41943 14.1664 3.2795 14.3051 3.10896 14.3051C2.93843 14.3051 2.7985 14.1664 2.7985 13.9973C2.7985 13.8282 2.93843 13.6895 3.10896 13.6895Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.14982 14.5001C4.14982 14.6779 4.00552 14.8252 3.82186 14.8252C3.64258 14.8252 3.49391 14.6822 3.49391 14.5001C3.49391 14.3181 3.64258 14.175 3.82186 14.175C4.00114 14.175 4.14982 14.3224 4.14982 14.5001Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.91504 14.9163C4.91504 15.0984 4.76637 15.2414 4.58709 15.2414C4.40343 15.2414 4.25913 15.094 4.25913 14.9163C4.25913 14.7342 4.40781 14.5912 4.58709 14.5912C4.76637 14.5912 4.91504 14.7386 4.91504 14.9163Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.39159 15.5752C5.20794 15.5752 5.06364 15.4278 5.06364 15.2501C5.06364 15.068 5.21231 14.925 5.39159 14.925C5.57525 14.925 5.71955 15.0724 5.71955 15.2501C5.72392 15.4322 5.57525 15.5752 5.39159 15.5752Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.23122 15.8266C6.04319 15.8266 5.89015 15.6749 5.89015 15.4885C5.89015 15.3021 6.04319 15.1504 6.23122 15.1504C6.41925 15.1504 6.57229 15.3021 6.57229 15.4885C6.57229 15.6749 6.41925 15.8266 6.23122 15.8266Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.76021 15.6359C6.76021 15.4538 6.90888 15.3065 7.09254 15.3065C7.27619 15.3065 7.42486 15.4538 7.42486 15.6359C7.42486 15.818 7.27619 15.9654 7.09254 15.9654C6.90888 15.9654 6.76021 15.818 6.76021 15.6359Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.96709 16C7.78781 16 7.64351 15.8569 7.64351 15.6792C7.64351 15.5015 7.78781 15.3628 7.96709 15.3628C8.14637 15.3628 8.29067 15.5058 8.29067 15.6792C8.2863 15.8569 8.142 16 7.96709 16Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83729 15.922C8.6755 15.922 8.54431 15.792 8.54431 15.6316C8.54431 15.4712 8.6755 15.3411 8.83729 15.3411C8.99908 15.3411 9.13026 15.4712 9.13026 15.6316C9.13026 15.7963 8.99908 15.922 8.83729 15.922Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.69874 15.7399C9.55881 15.7399 9.44512 15.6272 9.44512 15.4885C9.44512 15.3498 9.55881 15.2371 9.69874 15.2371C9.83867 15.2371 9.95236 15.3498 9.95236 15.4885C9.95236 15.6272 9.83867 15.7399 9.69874 15.7399Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3239 15.2501C10.3239 15.133 10.4201 15.0377 10.5382 15.0377C10.6563 15.0377 10.7525 15.133 10.7525 15.2501C10.7525 15.3671 10.6563 15.4625 10.5382 15.4625C10.4201 15.4625 10.3239 15.3671 10.3239 15.2501Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1722 14.9163C11.1722 14.8209 11.2509 14.7473 11.3428 14.7473C11.439 14.7473 11.5177 14.8253 11.5177 14.9163C11.5177 15.0117 11.439 15.0897 11.3428 15.0897C11.2509 15.0897 11.1722 15.0117 11.1722 14.9163Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1125 14.6692C12.0163 14.6692 11.9419 14.5912 11.9419 14.5002C11.9419 14.4048 12.0206 14.3268 12.1125 14.3268C12.2087 14.3268 12.2874 14.4048 12.2874 14.5002C12.283 14.5955 12.2087 14.6692 12.1125 14.6692Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8252 14.149C12.7421 14.149 12.6721 14.0797 12.6721 13.9973C12.6721 13.9149 12.7377 13.8456 12.8252 13.8456C12.9083 13.8456 12.9782 13.9149 12.9782 13.9973C12.9782 14.0797 12.9083 14.149 12.8252 14.149Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4767 13.5508C13.4024 13.5508 13.3456 13.4901 13.3456 13.4208C13.3456 13.3471 13.4024 13.2907 13.4767 13.2907C13.5511 13.2907 13.6079 13.3514 13.6079 13.4208C13.6079 13.4945 13.5467 13.5508 13.4767 13.5508Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0583 12.6188C14.1458 12.6188 14.2157 12.6882 14.2157 12.7749C14.2157 12.8616 14.1458 12.9309 14.0583 12.9309C13.9709 12.9309 13.9009 12.8616 13.9009 12.7749C13.9009 12.6882 13.9709 12.6188 14.0583 12.6188Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.723 12.0683C14.723 12.155 14.6531 12.2243 14.5656 12.2243C14.4782 12.2243 14.4082 12.155 14.4082 12.0683C14.4082 11.9816 14.4782 11.9122 14.5656 11.9122C14.6531 11.9122 14.723 11.9816 14.723 12.0683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8105 11.3097C14.8105 11.2143 14.8892 11.1363 14.9854 11.1363C15.0816 11.1363 15.1603 11.2143 15.1603 11.3097C15.1603 11.405 15.0816 11.4831 14.9854 11.4831C14.8892 11.4831 14.8105 11.405 14.8105 11.3097Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1384 10.5121C15.1384 10.4123 15.2215 10.33 15.3221 10.33C15.4226 10.33 15.5057 10.4123 15.5057 10.5121C15.5057 10.6118 15.4226 10.6941 15.3221 10.6941C15.2171 10.6941 15.1384 10.6118 15.1384 10.5121Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5625 9.90084C15.4401 9.90084 15.3395 9.80113 15.3395 9.67976C15.3395 9.55838 15.4401 9.45868 15.5625 9.45868C15.685 9.45868 15.7856 9.55838 15.7856 9.67976C15.7856 9.80113 15.685 9.90084 15.5625 9.90084Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7069 9.06424C15.5757 9.06424 15.4664 8.95587 15.4664 8.82582C15.4664 8.69577 15.5757 8.5874 15.7069 8.5874C15.838 8.5874 15.9474 8.69577 15.9474 8.82582C15.9474 8.95587 15.8424 9.06424 15.7069 9.06424Z",
			fill: "black"
		})
	]
});
export default SvgGreyIconLogo;
